import React, { useState, useEffect } from "react";
import { Space, Form, Input, Select, Button, Checkbox, Typography, 
         Divider, Radio, Slider, Steps} from "antd";
// import axios from "axios";
import ReactMarkdown from 'react-markdown'

import MarkdownIt from 'markdown-it';

import { mclOpen } from "../../api/Mcl";
import { CAREPLAN_API_KEY, Url } from "../../constants/Global";

import { PasswordModal, ResubmitPlanModal, ResendPlanModal } from "../../components/PlanComponents"
import { use } from "react";


const { TextArea } = Input;
const { Title, Text } = Typography;

// > [Schedule your session here.](https://calendly.com/mycarelinq)

const labelMap = {
    caregiverLocation: {n: "caregiverLocation", q: "Where are you currently located?", p: "City, State"},
    recipientLocation: {n: "recipientLocation", q: " Where is the person you're caring for located?", p: "City, State"},
    careDuration: {n: "careDuration", q: "How long have you been providing care?", p: "e.g. 6 months, 2 years"},
    weeklyHours: {n: "weeklyHours", q: "On average, how many hours per week do you spend caregiving?"},
    tasks: {n: "tasks", q: "Which caregiving tasks do you handle regularly?", 
      p: "transportation, meal preparation, bathing/dressing, medications, finances, companionship, medical decision making"},
    helpers: {n: "helpers", q: "Who else supports you in your caregiving role?", 
      p: "no one, family, paid professional, friends, community/faith-based support"},
    distress: {n: "distress", q: "What’s felt especially hard about caregiving lately?", 
      p: "This can be emotional, logistical, or anything else you'd like to share."},
    feeling: {n: "feeling", q: "What challenges or feelings have you been experiencing recently?", 
      p: "Feeling emotionally drained, Confused about what’s expected of you,Unsafe or emotionally harmed,Delaying your own needs,Feeling overwhelmed or close to burnout (Scale: Never → Always) "},
    confidence: {n: "confidence", q: " Which caregiving areas do you feel least confident or clear about?" },
    workImpact: {n: "workImpact", q: "Has caregiving affected your work or income in any way?", 
      p: "yes or no, please share more"},
    // expenseResponse: {n: "expenseResponse", q: "If a $1,000 care-related expense came up today, how would you manage it?", 
    //   p: "savings, credit, delay, ask family, unsure, please elaborate"},
    supportTools: {n: "supportTools", q: "Have you already tried any tools, services, or providers that didn't meet your expectations?"}, 
    supportTypes: {n: "supportTypes", q: "Which types of support would you consider accepting if offered?", 
      p: "emotional support, legal/financial help, care planning, respite care, finding housing, paid caregiver support,  please elaborate"},
    personalInsight: {n: "personalInsight", q: "(Optional) What’s something you wish others better understood about your caregiving situation?"},
    personalFuture: {n: "personalFuture", q: "(Optional) What worries you most about the future of this care situation?"},
    personalSituation: {n: "personalSituation", q: "(Optional) If you could reshape your caregiving situation in any way, what would that look like?"},
  }

const mclInitialValues = {
        [labelMap.caregiverLocation.n]: "San Francisco, California",
        [labelMap.recipientLocation.n]: "Sacramento, CA",
        [labelMap.careDuration.n]: "18 months",
        [labelMap.weeklyHours.n]: "15",
        [labelMap.tasks.n]: "I've had to manage more and more as I find things. I'm providing rides because it's generally unsafe for my mom to drive anymore. I'm running errands for her and now need to discuss how to manage her finances and be her POA for medical decisions.",
        [labelMap.helpers.n]: "my sister but she is busy and doesn't have a lot of time",
        [labelMap.distress.n]: "I really don't want to be doing this but there isn't any alternative. I feel like this is being forced on to me. My mother plays the victim. She is moody and doesn't express any appreciation for how much time and resources its taking me to care for her. I have no idea where or who to talk to about how to apply for POA. I don't have an understanding of how she is doing financially. I don't know where were records are or where she keeps her passwords. I'm really frustrated and I feel like I can't talk about it because I sound angry all the time. And no one understands.",
        [labelMap.feeling.n]: "I'm so tired and stressed about how much work this is. I have a feeling its only going to get worse. I really don't know what to do to help my mom. I really don't want to do this on my own. I've also lost sleep, and get migraines, and emotionally I'm all over the place.",
        [labelMap.confidence.n]: "Her estate stuff, POA, Advance Directive, insurance and what her wishes are.",
        [labelMap.workImpact.n]: "I've taken time away from work to figure out what is going on in her home. Every time I visit I find something new. I'm spending my money on small things like drug store items, groceries, and transportation.",
        [labelMap.supportTools.n]: "Not yet. I'm still trying to figure where things are.",
        [labelMap.supportTypes.n]: "I really don't have the time or capacity to take this on. I'm not an expert and the time it takes to research each new thing totally distracts me from work, family, and my own needs.",
        [labelMap.personalInsight.n]: "It's really not fair to put something in this type of position. I feel like this situation is totally out of control and I have to make it better somehow.",
        [labelMap.personalFuture.n]: "If she has an accident that puts her in the hospital, I'm worried that I'll have to be her main support and I don't want that. I'm also worried that she will outlive her money.",
        [labelMap.personalSituation.n]: "Honestly, I wish I didn't have to be the one doing all of this for my mom. I'm so stressed and upset that is taking all my time and focus.",
}


export const  DemoPlan4 = (client = "") => {
  const [qa, setQA] = useState("");
  const [prompt, setPrompt] = useState("");
  const [description, setDescription] = useState("mcl");
  const [plan, setPlan] = useState("");
  const [loading, setLoading] = useState(false);
  const [mailing, setMailing] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [authkey, setAuthkey] = useState(null);
  const [changekey, setChangekey] = useState(null);
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState("");
  const [org, setOrg] = useState("")
  const [planHtml, setPlanHtml] = useState("<></>");
  const [status, setStatus] = useState("")
  const [initialValues, setInitialValues] = useState({})
  const [showResubmit, setShowResubmit] = useState(false)
  const [showResend, setShowResend] = useState(false)
  const [clientId, setClientId] = useState(client?.client)
   

  const md = new MarkdownIt();

  const validatePassword = () => {
    setAuthkey(changekey);
  }

  const handleResubmit = () => {
    setShowResubmit(false);
  }

  const handleResend = () => {
    setShowResend(false);
  }

  const handleProcess = async (values) => {
    console.log(values)
    setLoading(true);
    const currentQA = "Questionnaire with Answers:\n\n" + Object.entries(values)
      .map(([key, value]) => `Question: ${labelMap[key].q} ${labelMap[key]?.p ? "("+labelMap[key]?.p+")" : ""} \nAnswer: ${value ? value: 'No answer'} \n`)
      .join('\n')

    setQA(currentQA)
    setPlan("");
    // console.log(Url.PLAN.concat("/ai-wb"));
    console.log(Url.PLAN.concat("/ai"));
    try {      
      // const response = await mclOpen.post(Url.PLAN.concat("/ai-wb"),
      const response = await mclOpen.post(Url.PLAN.concat("/ai"),
        JSON.stringify({
          apiKey: CAREPLAN_API_KEY,
          clientId,
          email,
          org,
          qa: currentQA,
          // prompt,
          description,
        }),
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      
      console.log("Response:", response?.data);
      setPlan(response?.data || "No result returned.");
      setPlanHtml(md.render(response?.data ?? ""));
      setStep(3)
    } catch (err) {
      console.log(`Error processing request error: ${err.message}`);
      setPlanHtml(`Error processing request error: ${err.message}`);
      setShowResubmit(true)
    }
    setLoading(false);
  };

  const handleEmail = async () => {
    console.log("Sending email")
    try {      
      setMailing(true);
      const response = await mclOpen.post(Url.PLAN.concat("/ai-send"),
        JSON.stringify({
          email,
          org,
          qa,
          plan,
        }),
        {
          headers: { "Content-Type": "application/json" },
        }
      )

      console.log("sending successful!")
      setMailing(false)
      setStep(4)
      //console.log("Response:", response?.data);
      //setPlan(response?.data || "No result returned.");
      //setStep(4)
    } catch (err) {
      console.log("sending failed!!")
      setMailing(false)
      setShowResend(true)
    }
  }

  useEffect(() => {
    const compareHash = async (str) => {
      const encoder = new TextEncoder();
      const data = encoder.encode(str);
      const hashBuffer = await crypto.subtle.digest("SHA-256", data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
      var isCheck = false;
      // console.log(str, hashHex);
      // if (hashHex === "5d601c9f3f0339f619b6690cf01635231a8434f780e1e430096b91b4e3df5aab") {
      //   // default mcl
      //   setIsAuthorized(true);
      // } 
      // aon  f46214271123719994ad0331840c3510bace3f9b0ee4dd557ea0dd34823dd41e
      // silver f14a6134f7629a194b05c6d3b57c402f9160d7e3534d6693efcf842d1eba7fa4
      // return hashHex;
      switch (hashHex) {
        case "5d601c9f3f0339f619b6690cf01635231a8434f780e1e430096b91b4e3df5aab":
          setDescription("mcl");
          setOrg("MyCareLinq")
          setIsAuthorized(true);
          setInitialValues(mclInitialValues)

          // isCheck = true          
          break;
        case "f14a6134f7629a194b05c6d3b57c402f9160d7e3534d6693efcf842d1eba7fa4":
          setDescription("silver");
          setOrg("Silver Lake")
          setIsAuthorized(true);          
          break;
        case "bf863ec0c255ad5c32379bf7cf4366e1e177f8f2aafe39757608ba8aa3880080":
          setDescription("guest");
          setOrg("Guests")
          setIsAuthorized(true);          
          break;

        case "f46214271123719994ad0331840c3510bace3f9b0ee4dd557ea0dd34823dd41e":
          setDescription("aon");
          setOrg("Aon")
          // setIsAuthorized(true);          
          isCheck = true          
          break;
        case "c280284088cce74ff48b93b940286001ab240f3bea8d2fd8214d908823652e7b":
          setDescription("aon");
          setOrg("Aon")
          // setIsAuthorized(true);
          isCheck = true          
          break;
        case "f04bf33843736a997797bbcb4186c9fa0ca6314ba6804569b8c7beaf92e5abcd":
          setDescription("aon");
          setOrg("Aon")
          // setIsAuthorized(true);
          isCheck = true          
          break;
        case "31eecbe97a67437989fe956be6c966e7598530a2c13fdd81e36403b1c4f7b390":
          setDescription("aon");
          setOrg("Aon")
          // setIsAuthorized(true);
          break;

        default:
          setDescription("none");
      }

      if (isCheck) {
        try {      
          // set(true);
          const response = 
            await mclOpen.get(Url.PLAN.concat("/access/", hashHex))
              .then((res) => {
                console.log("response", res.data);
                setIsAuthorized(true)
              })
              .catch((error) => {
                const msg = "Access limit exceeded";
                setStatus(msg);
                console.log(msg);
              })

        } catch (err) {
          console.log("Access check failed!!")
        }      
      }
    };

    if (!isAuthorized) {
      compareHash(changekey);
    }
  
  }, [authkey])

  
const { Title, Paragraph } = Typography;
const { Option } = Select;
const { Step } = Steps
const { TextArea } = Input

const [form] = Form.useForm();

const handleEmailOrgSubmit = (values) => {
  setEmail(values.email)
  setOrg(values.org)
  setStep(1)
}

const handleBegin = () => {
  setStep(2)
}


const ruleRequired = [
    { required: true, message: "Please fill out this field." }
  ]
  
  


  return !isAuthorized ? <PasswordModal handleOk={validatePassword} modalShow={!isAuthorized} onKey={(val) => {setChangekey(val)}} status={status}/> : 
  (
    <div style={{ width: '90%', margin: "auto", padding: 24 }}>
      <ResubmitPlanModal handleOk={handleResubmit} modalShow={showResubmit}/>
      <ResendPlanModal handleOk={handleResend} modalShow={showResend} email={email}/>
      <Steps current={step} style={{ marginBottom: 24 }}>
        <Step title="Welcome" />
        <Step title="Before You Begin" />
        <Step title="Questionnaire" />
        <Step title="Family Care Plan" />
        <Step title="Thank You" />
      </Steps>

      {step === 0 && (
        <Form layout="vertical" onFinish={handleEmailOrgSubmit}  initialValues={{ org: org }}>
          <Typography style={{ marginBottom: 24 }}>
            <Title level={3}>Welcome to My CareLinq</Title>
            <Paragraph>You’re in the right place.</Paragraph>
            <Paragraph>
              This experience is part of a family caregiving benefit provided by your employer, health plan, or membership organization — in partnership with My CareLinq.
              We’ll help you create a personalized family caregiving plan, with expert support, curated services, and actionable next steps to help you and your family navigate care with confidence.
            </Paragraph>
            <Title level={4}>What to Expect</Title>
            <ul>
              <li>You’ll answer a few questions about yourself and your caregiving role</li>
              <li>It takes about 10–20 minutes</li>
              <li>You’ll receive a customized care plan that can be saved, updated, and shared</li>
            </ul>
            <Title level={4}>Verify Your Affiliation</Title>
          </Typography>
          <Form.Item name="org" label="Organization" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit">Proceed to Enrollment</Button>
        </Form>
      )}

      {step === 1 && (
          <div style={{ maxWidth: 700, margin: 'auto', padding: '2rem' }}>
          <Typography>
            <Title level={2}>Enterprise Enrollment Page</Title>
            <Title level={3}>Welcome to Your Caregiving Benefit</Title>
            <Paragraph>
              This caregiving benefit is brought to you by <strong>[Organization Name]</strong> and My CareLinq.
            </Paragraph>

            <Title level={4}>What to Expect</Title>
            <ul>
              <li>Answer a few brief questions about your caregiving situation</li>
              <li>Estimated time: 10–20 minutes</li>
              <li>You’ll receive a personalized family care plan you can download, email, or refine later</li>
            </ul>

            <Title level={4}>Your Benefit Package Includes</Title>
            <ul>
              <li>Self-driven family care plan generation — complete a guided assessment and receive a customized plan you can update over time</li>
              <li>Schedule time with a Care Concierge — review your plan, explore solution options, and upgrade to full-service support if needed</li>
            </ul>

            <Title level={4}>Ready to Build Your Family Care Plan?</Title>

            <Title level={5}>Before You Begin</Title>
            <ul>
              <li>You’ll answer questions about your caregiving role, your loved one’s health, and any support systems you may already have</li>
              <li>This will take about 10–20 minutes</li>
              <li>You can pause, save, and return at any time</li>
            </ul>
            <Paragraph>
              <strong>Why we ask:</strong> This helps us tailor your care plan and recommendations — and prepares our team to support you if you want more help.
            </Paragraph>

            <Title level={5}>Tips Before You Start</Title>
            <ul>
              <li>Be honest — your information is private and secure</li>
              <li>Take your time — revisit questions if you need</li>
              <li>We’re here for you — your responses inform the best path forward</li>
            </ul>

            <div style={{ margin: '2rem 0' }}>
              <Button type="primary" size="large" onClick={handleBegin}>
                Begin My Family Care Plan
              </Button>
            </div>

          </Typography>
        </div>
      )}

      {step === 2 && (
        <Form layout="vertical" form={form} onFinish={handleProcess}
          initialValues={initialValues}
        >
        <h3><bold>Let’s start with a few quick questions to get oriented—then you’ll have a chance to share more about your situation if you’d like.</bold></h3>
        <Divider orientation="left" orientationMargin={0}>Core Questions</Divider>
          <Form.Item label={labelMap.caregiverLocation.q} >
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.caregiverLocation.p}
            </Text>
            <Form.Item name={labelMap.caregiverLocation.n} rules={ruleRequired}>
              <Input/>
            </Form.Item>
          </Form.Item>

          <Form.Item label={labelMap.recipientLocation.q} >
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.recipientLocation.p}
            </Text>
            <Form.Item name={labelMap.recipientLocation.n} rules={ruleRequired}>
              <Input/>
            </Form.Item>
          </Form.Item>

          <Form.Item label={labelMap.careDuration.q} >
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.careDuration.p}
            </Text>
            <Form.Item name={labelMap.careDuration.n} rules={ruleRequired}>
              <Input/>
            </Form.Item>
          </Form.Item>

          <Form.Item label={labelMap.weeklyHours.q} >
          <Form.Item name={labelMap.weeklyHours.n} rules={ruleRequired}>
            <Input />
          </Form.Item>
          </Form.Item>

          <Form.Item label={labelMap.tasks.q} >
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.tasks.p}
            </Text>
            <Form.Item name={labelMap.tasks.n} rules={ruleRequired}>
              <Input.TextArea rows={4} />
            </Form.Item>
          </Form.Item>
 
          <Form.Item label={labelMap.helpers.q} >
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.helpers.p}
            </Text>
          <Form.Item name={labelMap.helpers.n} rules={ruleRequired}>
            <Input.TextArea rows={2}/>
         </Form.Item>
         </Form.Item>

          <Divider orientation="left" orientationMargin={0}>Distress & Burnout</Divider>

          <Form.Item label={labelMap.distress.q} >
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.distress.p}
            </Text>
            <Form.Item name={labelMap.distress.n} rules={ruleRequired}>
              <Input.TextArea rows={4}/>
            </Form.Item>
          </Form.Item>

          <Form.Item label={labelMap.feeling.q} >
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              <ul>
                <li>Feeling emotionally drained</li>
                <li>Confused about what’s expected of you</li>
                <li>Unsafe or emotionally harmed</li>
                <li>Delaying your own needs</li>
                <li>Feeling overwhelmed or close to burnout</li>
              </ul>           
              <p>(Scale: Never → Always)</p>
            </Text>
            <Form.Item name={labelMap.feeling.n} rules={ruleRequired}>
              <Input.TextArea />
            </Form.Item>
          </Form.Item>

          <Divider orientation="left" orientationMargin={0}>Confidence Mapping</Divider>

          <Form.Item label={labelMap.confidence.q} >
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.confidence.p}
            </Text>
            <Form.Item name={labelMap.confidence.n} rules={ruleRequired}>
              <Input.TextArea rows={2} 
                placeholder=""
              />
            </Form.Item>
          </Form.Item>

          <Divider orientation="left" orientationMargin={0}>Financial & Work Impact</Divider>

          <Form.Item label={labelMap.workImpact.q}>
            <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.workImpact.p}
            </Text>
            <Form.Item name={labelMap.workImpact.n} noStyle>
              <Input.TextArea rows={3} />
            </Form.Item>
          </Form.Item>

          <Divider orientation="left" orientationMargin={0}>Support Needs</Divider>
          <Form.Item label={labelMap.supportTools.q}>
            {/* <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.supportTools.p}
            </Text> */}
            <Form.Item name={labelMap.supportTools.n}>
              <Input.TextArea rows={3} />
            </Form.Item>
          </Form.Item>

          <Form.Item label={labelMap.supportTypes.q}>
          <Text type="secondary" style={{ fontSize: '12px', marginLeft: '12px'  }}>
              {labelMap.supportTypes.p}
            </Text>
            <Form.Item name={labelMap.supportTypes.n}>
              <Input.TextArea rows={3} />
            </Form.Item>
          </Form.Item>

          <Divider orientation="left" orientationMargin={0}>Optional Personal Insight</Divider>

          <Form.Item name={labelMap.personalInsight.n} label={labelMap.personalInsight.q}>
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item name={labelMap.personalFuture.n} label={labelMap.personalFuture.q}>
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item name={labelMap.personalSituation.n} label={labelMap.personalSituation.q}>
            <Input.TextArea rows={4} />
          </Form.Item>

          <Divider orientation="left" orientationMargin={0}>Review & Next Steps</Divider>

          <Divider orientation="left" orientationMargin={0}>Before You Submit</Divider>
            <Typography>
            <Paragraph>
              Take a moment to review your answers. You can go back to any section and make changes.
              You do not need to answer every question to receive support—just do your best.
            </Paragraph>

            <Divider orientation="left" orientationMargin={0}>What Happens Next</Divider>
            <Paragraph>
              After you submit, our Care Concierge system will generate a personalized Family Care Plan based on your responses.
              Within a few minutes, you’ll receive your plan — including a summary of your caregiving situation, practical next steps tailored to your responses, and relevant suggestions and resources to help you move forward.
            </Paragraph>
            <Paragraph>
              You may also receive an invitation to connect with a Care Concierge for one-on-one help with implementing your plan and coordinating next steps (optional).
            </Paragraph>

            <Paragraph>
              Thank you for sharing your story. Your responses help us better support you and your loved one in the journey ahead.
            </Paragraph>

            <div style={{ margin: '2rem 0' }}>
              <Form.Item>
                <Button type="primary" size="medium" htmlType="submit"  loading={loading}>
                  Submit Responses and Generate My Care Plan
                </Button>
              </Form.Item>
            </div>

            <Paragraph type="secondary" style={{ fontSize: '0.9rem' }}>
              By clicking submit, your responses will be securely sent to our Care Concierge system. Within a few minutes, you’ll receive your personalized care plan via email or secure link.
            </Paragraph>
            <Paragraph type="secondary" style={{ fontSize: '0.9rem' }}>
              Need help? Contact us at <a href="mailto:support@mycarelinq.com">support@mycarelinq.com</a> or &nbsp;
              <a href="https://calendly.com/mycarelinq">Schedule a Concierge Session</a>
            </Paragraph>
          </Typography>


        </Form>
      )}

      {step === 3 && (
        <div style={{ width: '80%', margin: 'auto', padding: '2rem' }}>
        <Title level={3}>Family Care Plan</Title>

          <Typography>
            {/* <ReactMarkdown>{plan}</ReactMarkdown> */}
            <div dangerouslySetInnerHTML={{ __html: planHtml }} />
            </Typography>

          <Button type="primary" size="large" onClick={handleEmail} loading={mailing}>
            Email Family Care Plan
          </Button>
        </div>
      )}

      {step === 4 && (
        <div className="max-w-2xl mx-auto p-8 text-center" role="main" aria-label="Thank You Page">
          <h1 className="text-3xl font-bold mb-4">Your Family Care Plan Is On Its Way</h1>

          <p className="text-lg mb-4">
            <strong>Thank You for Trusting MyCareLinq</strong>
          </p>

          <p className="text-md mb-4">
            Your personalized family caregiving plan has been generated and is on its way to your inbox.
            You can review it, return anytime to update, or share it with someone you trust.
          </p>

          <p className="text-md mb-4">
            If you requested a follow-up from a Care Concierge, we’ll be reaching out shortly.
          </p>

          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded mb-4">
            <p className="text-sm text-blue-700">
              Check your email for a copy of your plan. If it’s not there within a few minutes, please check your spam folder or contact us at <strong>support@mycarelinq.com</strong>.
            </p>
          </div>

          <div className="bg-gray-50 border border-gray-300 p-4 rounded mb-4">
            <p className="text-sm text-gray-800">
              You may now <strong>close this tab</strong> or return to your organization’s benefits portal.<br />
              To update your plan later, visit <strong>www.mycarelinq.com</strong> and log in with your email.<br />
              Need help or prefer to talk to someone? Call us at <strong>1-408-214-2416</strong>.
            </p>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={() => window.location.href = '/'}
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
            >
              Return to Homepage
            </button>
            <button
              onClick={() => {
                 window.open("https://calendly.com/mycarelinq", "_blank");                }
              }
              className="bg-gray-200 text-gray-800 px-6 py-2 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
            >
              Schedule a Concierge Follow-Up
            </button>
          </div>
        </div>      
      )}
    </div>
  );

}
